import TipIcon from '@/components/svgs/basic/tip';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyleSheet, View} from 'react-native';
import {LotteryMode} from '../mix-lottery-service';
import {MAIN_KEY} from '../constant';
import Text from '@/components/basic/text';
import theme from '@/style';

const LotteryTip = ({mode}: {mode?: LotteryMode}) => {
  const {t} = useTranslation();
  const Two = [
    [
      {title: 'Big', value: MAIN_KEY.Big},
      {title: 'Small', value: MAIN_KEY.Small},
    ],
    [
      {title: 'Odd', value: MAIN_KEY.Odd},
      {title: 'Even', value: MAIN_KEY.Even},
    ],
  ];

  const F_P_C = [
    {
      label: 'Fish',
      value: MAIN_KEY.Fish,
    },
    {
      label: 'Prawn',
      value: MAIN_KEY.Prawn,
    },
    {
      label: 'Crab',
      value: MAIN_KEY.Crab,
    },
  ];

  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.container}>
        <TipIcon />
        <div style={stylesWeb.content}>
          {mode === LotteryMode['Two Side'] &&
            Two.map((item, _i) => (
              <div
                key={_i}
                style={{
                  ...stylesWeb.row,
                  ...(_i !== 0 ? stylesWeb.rowGap : null),
                }}>
                {item.map(({title, value}, _ii) => (
                  <div
                    key={title}
                    style={_ii === 0 ? stylesWeb.dividerItem : undefined}>
                    <span style={stylesWeb.mainText}>
                      {t(`mix-lotto.label.${title}`)}:&nbsp;
                    </span>
                    <span style={stylesWeb.valueText}>{value}</span>
                  </div>
                ))}
              </div>
            ))}
          {mode === LotteryMode.FishPrawnCrab && (
            <div style={stylesWeb.row}>
              {F_P_C.map((item, _i) => (
                <div
                  key={_i}
                  style={_i !== F_P_C.length - 1 ? stylesWeb.dividerItem : {}}>
                  <span style={stylesWeb.mainText}>
                    {item.label}&nbsp;:&nbsp;
                  </span>
                  <span style={stylesWeb.valueText}>{item.value}</span>
                </div>
              ))}
            </div>
          )}
          {mode === LotteryMode['1 Digit'] ? (
            <span style={stylesWeb.valueText}>
              {t('mix-lotto.tip.1digitModeTip')}
            </span>
          ) : null}
          {mode !== LotteryMode['1 Digit'] &&
          mode !== LotteryMode.FishPrawnCrab &&
          mode !== LotteryMode['Two Side'] ? (
            <span style={stylesWeb.valueText}>
              {t('mix-lotto.tip.numberModeTip')}
            </span>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <View style={[theme.flex.row, theme.flex.centerByCol, styles.container]}>
      <TipIcon />
      <View style={[theme.margin.lefts, theme.flex.flex1]}>
        {mode === LotteryMode['Two Side'] &&
          Two.map((item, _i) => (
            <View key={_i} style={[_i !== 0 && styles.tipRow, theme.flex.row]}>
              {item.map(({title, value}, _ii) => (
                <View
                  key={title}
                  style={_ii === 0 ? styles.tipItem : undefined}>
                  <Text size="medium" fontFamily="fontInterBold" main>
                    {t(`mix-lotto.label.${title}`)}:&nbsp;
                    <Text size="medium" main>
                      {value}
                    </Text>
                  </Text>
                </View>
              ))}
            </View>
          ))}

        {mode === LotteryMode.FishPrawnCrab && (
          <View style={[theme.flex.row, theme.flex.centerByCol]}>
            {F_P_C.map((item, _i) => (
              <View
                style={[
                  theme.flex.row,
                  theme.flex.centerByCol,
                  _i !== F_P_C.length - 1 && styles.tipItem,
                ]}
                key={_i}>
                <Text fontFamily="fontInterBold" size="medium" main>
                  {item.label}&nbsp;:&nbsp;
                </Text>
                <Text size="medium" main>
                  {item.value}
                </Text>
              </View>
            ))}
          </View>
        )}
        {mode === LotteryMode['1 Digit'] && (
          <Text fontWeight="500">{t('mix-lotto.tip.1digitModeTip')}</Text>
        )}
        {mode !== LotteryMode['1 Digit'] &&
          mode !== LotteryMode.FishPrawnCrab &&
          mode !== LotteryMode['Two Side'] && (
            <Text fontWeight="500">{t('mix-lotto.tip.numberModeTip')}</Text>
          )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  tipRow: {
    marginTop: 2,
  },
  tipItem: {
    paddingRight: 8,
    marginRight: 8,
    borderRightColor: '#5F6975',
    borderRightWidth: 1,
  },
});

const stylesWeb: Record<string, React.CSSProperties> = {
  container: {
    padding: '0.5rem 0.75rem',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    marginLeft: '0.5rem',
    flex: 1,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  rowGap: {
    marginTop: '0.125rem',
  },
  dividerItem: {
    paddingRight: '0.5rem',
    marginRight: '0.5rem',
    borderRight: '1px solid #5F6975',
  },
  mainText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#31373D',
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
  },
  valueText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#31373D',
    fontWeight: 500,
  },
};

export default React.memo(LotteryTip);
